function cancelationReasons(brand) {
  return {
    covid: {
      id: 0,
      imageUrl: '/covid_image.jpg',
      headline: 'Talk to us - we may be able to help',
      paragraph: `We understand that you have to make tough decisions for your business, but at ${brand}, ` +
        'we\'re committed to helping our customers in times of need.',
      ctaText: 'Chat now',
      inputLabel: 'COVID-19'
    },
    training: {
      id: 1,
      imageUrl: '/covid_image.jpg',
      headline: 'Need extra help?',
      paragraph: 'Sign up for a group 45-minute demo, and you can get any questions you may have answered.',
      ctaText: 'Schedule now',
      inputLabel: "There isn't enough training available"
    },
    time: {
      id: 2,
      imageUrl: '/covid_image.jpg',
      headline: 'Not finding enough time to use the software?',
      paragraph: 'We know you\'re busy running your business,' +
        ` and ${brand} was built to make things easier and automated.` +
        ` Click below to watch a 3-minute video on setting up ${brand}` +
        ' to run your GMB activity on autopilot.',
      ctaText: 'Watch now',
      inputLabel: 'I had no time to use the software'
    },
    support: {
      id: 3,
      imageUrl: '/covid_image.jpg',
      headline: "Customer service didn't meet your expectations?",
      paragraph: 'We take great pride in helping our customers as quickly as possible and' +
        ' delivering an excellent customer support experience. If we fell short of that goal,' +
        ' we\'d love to have a quick chat with you and see how we can do better.',
      ctaText: 'Chat now',
      inputLabel: 'I had issues with customer support'
    },
    bugs: {
      id: 4,
      imageUrl: '/covid_image.jpg',
      headline: 'Something not working how it should be?',
      paragraph: 'We have a very active development team and aim to resolve any software issues' +
        ' as quickly as possible. If something didn\'t work as expected,' +
        ' please let us know in the comment section on this form.',
      ctaText: 'Leave feedback',
      inputLabel: 'I had an issue with functionality'
    },
    cost: {
      id: 5,
      imageUrl: '/covid_image.jpg',
      headline: 'Talk to us - we may be able to help',
      paragraph: 'We know sometimes you have to make tough decisions for your business, but at' +
        ` ${brand}, we're committed to helping our customers in times of need.`,
      ctaText: 'Chat now',
      inputLabel: 'Out of budget or downsizing'
    },
    setup: {
      id: 6,
      imageUrl: '/covid_image.jpg',
      headline: "Let's help get you setup",
      paragraph: 'Sign up for a group 45-minute demo, and you can get any questions you may have answered.',
      ctaText: 'Review my account',
      inputLabel: "I couldn't get set up"
    },
    complicated: {
      id: 7,
      imageUrl: '/covid_image.jpg',
      headline: 'Tell us how we can make things simpler',
      paragraph: `We try to make ${brand} as easy to use as possible,` +
        ' so if you find something that is confusing or complicated, let us know.',
      ctaText: 'Leave feedback',
      inputLabel: 'It was too complicated for me'
    },
    closed: {
      id: 8,
      imageUrl: '/covid_image.jpg',
      headline: 'We are sad to see you go',
      paragraph: 'We know running a business of any size can be difficult, and we\'re sad to see you go.' +
        ' If you have any feedback, we would love for you to leave a comment on this page below.',
      ctaText: 'Leave feedback',
      inputLabel: 'My business is closing'
    },
    functionality: {
      id: 9,
      imageUrl: '/covid_image.jpg',
      headline: 'We are constantly developing new features',
      paragraph: 'Are we missing something you need?' +
        ' Check out our product <a href="https://localviking.com/feature-roadmap" target="_blank">roadmap</a> to see if we are currently working on it,' +
        ' or message us and let us know what you need.',
      ctaText: 'Leave feedback',
      inputLabel: 'Lack of functionality'
    },
    unready: {
      id: 10,
      imageUrl: '/covid_image.jpg',
      headline: 'Need extra help?',
      paragraph: 'Sign up for a group 45-minute demo, and you can get any questions you may have answered.',
      ctaText: 'Schedule now',
      inputLabel: `I'm not ready for ${brand}`
    }
  }
}

export default cancelationReasons
